<template>
    <div id="nodeTippy" style="display: none">
        <div v-if="Object.keys(clickedNode).length">
            <div v-if="clickedNode.isEdge">
                {{ clickedNode.data.name }}
            </div>
            <div v-else-if="clickedNode.classes.indexOf('distribution') != -1 && Object.keys(clickedPathInfo).length > 0">
                <div><b>Logical path: </b> <a target="_blank" :href="clickedPathInfo.url">{{ clickedPathInfo.name }}</a></div>
                <div>
                    <b>Data element: </b>
                    <a v-if="clickedPathInfo.data_element.name" target="_blank" :href="clickedPathInfo.data_element.url">{{ clickedPathInfo.data_element.name }}</a>
                    <span v-else> - </span>
                </div>
                <div><b>Definition: </b> <span v-if="clickedPathInfo.definition">{{ clickedPathInfo.definition }}</span><span v-else>-</span></div>
                <div><b>Format: </b>{{ clickedPathInfo.format }}</div>
                <div><b>Data type: </b>{{ clickedPathInfo.data_type }}</div>
            </div>
            <div v-else-if="clickedNode">
                <div><b>Name: </b> <a :href="clickedNode.data.url" target="_blank">{{ clickedNode.data.name }}</a></div>
                <div><b>Type: </b> {{ clickedNode.data.type }}</div>
                <div v-if="clickedNode.definition"><b>Definition: </b> {{ sentenceTrimmer(clickedNode.data.definition) }}</div>
                <div v-if="hasElement(clickedNode.classes, ['dataset', 'distribution'])">
                    <span v-if="clickedNode.data.hasSource && !isRequested(clickedNode.data.id, 'source', requestedData)">
                        <button type="button" class="source btn btn-sm btn-primary">
                            Show sources
                        </button>
                    </span>
                    <span v-if="clickedNode.data.hasGenerated && !isRequested(clickedNode.data.id, 'generated', requestedData)">
                        <button type="button" class="generated btn btn-sm btn-primary">
                            Show generated data
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { hasElement } from 'src/lib/utils.js'

import { sentenceTrimmer } from 'src/lib/utils.js'
import { isRequested } from 'src/lib/graph/data-lineage/utils.js'

export default {
    props: {
        // The node which is clicked
        clickedNode: {
            type: Object,
            required: true
        },
        // The path which is clicked
        clickedPathInfo: {
            type: Object,
            default: () => ({})
        },
        // A list of node id which are requested
        requestedData: {
            type: Array,
            required: true
        }
    },
    methods: {
        sentenceTrimmer: sentenceTrimmer,
        hasElement: hasElement,
        isRequested: isRequested,
    }
}

</script>

<style scoped>
#tippy-line {
    margin-bottom: 0.2em;
    margin-top: 0.2em
}
</style>
